import { useQuery } from "react-query";
import axios from "infra/http";

function useClassificacaoServicoPrestado() {
    return useQuery(
        "/v1/classificacao-servico-prestado",
        async (): Promise<{ nome: string; id: string; codigo: string }[]> => {
            const res = await axios.get("/v1/classificacao-servico-prestado");

            return res.data;
        }
    );
}

export default useClassificacaoServicoPrestado;
